import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { Avatar } from 'transfix-ui/components/Avatar'
import { Box } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import EditIssueStepsToResolve, {
  IEditIssueStepsProps,
} from '../../../ShipmentIssues/IssueRows/issueStepsToResolve/EditIssueStepsToResolve'
import { ControlledIssueOwner, IOwner } from '../ControlledIssueOwner'
import InlineEditDisplay, { IInlineEditDisplayProps } from './InlineEditDisplay'
import { TOnSubmitField } from './types'

interface ISelectOwnerProps {
  label?: string | null
  value?: IOwner | null
  onChange: TOnSubmitField
  readOnly?: boolean
  resolutionSteps?: IEditIssueStepsProps['resolutionSteps']
  onEditChange?: IInlineEditDisplayProps['onEditChange']
  showStepsToResolve?: boolean
}

/**
 * Owner dropdown
 */
export const SelectOwner: FC<ISelectOwnerProps> = ({
  label,
  onChange,
  onEditChange,
  readOnly = false,
  resolutionSteps,
  showStepsToResolve = false,
  value: currentOwner,
}) => {
  const { errors } = useFormContext()
  const isMpStepsToResolveEnabled = useFeatureFlag('mpStepsToResolve')
  const fieldNames = showStepsToResolve ? ['issueResolutionSteps', 'owner'] : 'owner'

  return (
    <InlineEditDisplay
      name={fieldNames}
      dataTest='owner-edit'
      label={label || 'Owner'}
      onSubmit={onChange}
      readOnly={readOnly}
      onEditChange={onEditChange}
      sectionName='Edit Owner'
      displayValue={
        <div>
          <Box display='flex' alignItems='center'>
            {currentOwner ? (
              <>
                <Avatar name={`${currentOwner.firstName} ${currentOwner.lastName}`} size='xsmall' />
                <Box ml={2}>
                  {currentOwner.firstName} {currentOwner.lastName}
                </Box>
              </>
            ) : (
              '--'
            )}
          </Box>
        </div>
      }>
      <div>
        <ControlledIssueOwner
          value={currentOwner}
          validationMessage={errors?.owner?.message}
          invalid={!!errors?.owner?.message}
        />
        {isMpStepsToResolveEnabled && showStepsToResolve && resolutionSteps?.length && (
          <EditIssueStepsToResolve resolutionSteps={resolutionSteps} showTitle />
        )}
      </div>
    </InlineEditDisplay>
  )
}

export default SelectOwner
